/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export const FILTER_TYPE = Object.freeze({
	RANGE: 'range',
	SELECT_VALUE: 'selectValue',
});

export const FILTER_RANGE_TYPE = Object.freeze({
	AFTER: 'after',
	BEFORE: 'before',
	BETWEEN: 'between',
	NOT_BETWEEN: 'not between',
});

export const FILTER_RANGE_SUBTYPE = Object.freeze({
	DATE_AND_TIME: 'date and time',
	DATE_ONLY: 'date only',
});
